module.exports = __webpack_public_path__ + "img/10.f5701a7b.jpg";